<script setup lang="ts">
import { computed, onMounted } from 'vue'
import SelectInput, { type Option } from '@/components/common/selects/SelectInput.vue'
import { useBoostCoreUsersStore } from '@/stores/useBoostCoreUsersStore'

const props = withDefaults(
  defineProps<{
    modelValue: string | null | undefined
    label?: string
    placeholder?: string
    required?: boolean
    disabled?: boolean
  }>(),
  { label: '', placeholder: 'Rechercher un collaborateur…', required: false, disabled: false },
)

const emit = defineEmits<{ (e: 'update:modelValue', value: string | null): void }>()

const usersStore = useBoostCoreUsersStore()

onMounted(async () => {
  if (usersStore.users.length === 0) await usersStore.fetchUsers()
})

const options = computed<Option[]>(() =>
  usersStore.users.map((u) => ({ id: u.uuid, value: u.uuid, label: usersStore.getUserLabel(u) })),
)

const proxy = computed<string | null>({
  get: () => props.modelValue ?? null,
  set: (val) => emit('update:modelValue', val),
})
</script>

<template>
  <SelectInput
    v-model="proxy"
    :options="options"
    :label="label"
    :placeholder="placeholder"
    :required="required"
    :disabled="disabled"
  />
</template>
